import { useState } from "react";
import { CircularProgress, Button } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import useDataUser from "hooks/useDataUser";
import useNotification from "hooks/useNotification";
// ----------------------------------------------------------------------

export default function DownloadUserProgBtn({ idUser }) {
  const [loading, setloading] = useState(false);
  const { downloadProgUser } = useDataUser();
  const { notif } = useNotification();
  const handleDownload = async () => {
    try {
      setloading(true);
      await downloadProgUser(idUser);
    } catch (error) {
      notif(null, error);
    }
    setloading(false);
  };
  return (
    <Button
      variant="outlined"
      color={idUser ? "warning" : "error"}
      onClick={handleDownload}
      disabled={loading}
    >
      {loading ? (
        <CircularProgress size="1rem" color="secondary" sx={{ mx: 2 }} />
      ) : (
        <ListAltIcon sx={{ mx: 2 }} />
      )}
      {idUser ? "Rapport CSV" : "Rapport de tous les utilisateurs"}
    </Button>
  );
}
